export type LayerIndexLike = {
  index: number | null | undefined;
};

const DEFAULT_NEXT_LAYER_INDEX = 1;

export function getNextHigherLayerIndex(layers: LayerIndexLike[] | undefined): number {
  if (!layers?.length) {
    return DEFAULT_NEXT_LAYER_INDEX;
  }

  const finiteIndices = layers.map((layer) => layer.index).filter((index): index is number => Number.isFinite(index));

  if (!finiteIndices.length) {
    return DEFAULT_NEXT_LAYER_INDEX;
  }

  return Math.max(...finiteIndices) + 1;
}
